import React from 'react';
import { WarningIcon } from './Icons';

interface WarningMessageProps {
  message: string;
}

export const WarningMessage: React.FC<WarningMessageProps> = ({ message }) => {
  return (
    <div className="absolute top-[100%] sm:top-[102%] left-0 flex items-center gap-1 mt-1 text-[#da1b41] text-[11px] leading-tight z-20">
      <WarningIcon />
      <span>{message}</span>
    </div>
  );
};
